import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actionTypes from './constants';

export const data = handleActions(
  {
    [actionTypes.INSTALLED_AT_INFO_REQUEST]: () => ({}),
    [combineActions(
      actionTypes.INSTALLED_AT_INFO_SUCCESS,
      actionTypes.INSTALLED_AT_INFO_SAVE_SUCCESS,
      actionTypes.VERIFY_INSTALLED_AT_INFO_SUCCESS,
    )]: (state, { payload }) => ({
      ...payload.details.installedAt,
      location: Object.values(payload?.location?.coordinate || {}),
    }),
  },
  {},
);

export const isLoading = handleActions(
  {
    [actionTypes.INSTALLED_AT_INFO_REQUEST]: () => true,
    [combineActions(
      actionTypes.INSTALLED_AT_INFO_SUCCESS,
      actionTypes.INSTALLED_AT_INFO_FAILURE,
    )]: () => false,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.INSTALLED_AT_INFO_REQUEST,
      actionTypes.INSTALLED_AT_INFO_SUCCESS,
      actionTypes.INSTALLED_AT_INFO_SAVE_REQUEST,
      actionTypes.INSTALLED_AT_INFO_SAVE_SUCCESS,
      actionTypes.VERIFY_INSTALLED_AT_INFO_REQUEST,
      actionTypes.VERIFY_INSTALLED_AT_INFO_SUCCESS,
    )]: () => ({}),
    [combineActions(
      actionTypes.INSTALLED_AT_INFO_FAILURE,
      actionTypes.INSTALLED_AT_INFO_SAVE_FAILURE,
      actionTypes.VERIFY_INSTALLED_AT_INFO_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export const isSaving = handleActions(
  {
    [combineActions(
      actionTypes.INSTALLED_AT_INFO_SAVE_REQUEST,
      actionTypes.VERIFY_INSTALLED_AT_INFO_REQUEST,
    )]: () => true,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.INSTALLED_AT_INFO_SAVE_SUCCESS,
      actionTypes.INSTALLED_AT_INFO_SAVE_FAILURE,
      actionTypes.VERIFY_INSTALLED_AT_INFO_SUCCESS,
      actionTypes.VERIFY_INSTALLED_AT_INFO_FAILURE,
    )]: () => false,
  },
  false,
);

export const saveSuccess = handleActions(
  {
    [actionTypes.INSTALLED_AT_INFO_SAVE_SUCCESS]: () => true,
    [combineActions(
      actionTypes.INSTALLED_AT_INFO_SAVE_REQUEST,
      actionTypes.INSTALLED_AT_INFO_SAVE_FAILURE,
      actionTypes.VERIFY_INSTALLED_AT_INFO_REQUEST,
      actionTypes.VERIFY_INSTALLED_AT_INFO_FAILURE,
    )]: () => false,
  },
  false,
);

export const lock = handleActions(
  {
    [actionTypes.INSTALLED_AT_INFO_SAVE_REQUEST]: () => null,
    [combineActions(
      actionTypes.INSTALLED_AT_INFO_SUCCESS,
      actionTypes.INSTALLED_AT_INFO_SAVE_SUCCESS,
      actionTypes.INSTALLED_AT_INFO_SAVE_FAILURE,
      actionTypes.VERIFY_INSTALLED_AT_INFO_SUCCESS,
    )]: (state, { payload }) => payload.lock || null,
  },
  null,
);

export const lockingErrorType = handleActions(
  {
    [actionTypes.INSTALLED_AT_INFO_SAVE_REQUEST]: () => null,
    [combineActions(
      actionTypes.INSTALLED_AT_INFO_SUCCESS,
      actionTypes.INSTALLED_AT_INFO_SAVE_SUCCESS,
      actionTypes.VERIFY_INSTALLED_AT_INFO_SUCCESS,
    )]: (state, { payload }) => payload.lockingErrorType,
  },
  null,
);

export const lockingErrors = handleActions(
  {
    [actionTypes.INSTALLED_AT_INFO_SAVE_REQUEST]: () => [],
    [combineActions(
      actionTypes.INSTALLED_AT_INFO_SUCCESS,
      actionTypes.INSTALLED_AT_INFO_SAVE_SUCCESS,
      actionTypes.VERIFY_INSTALLED_AT_INFO_SUCCESS,
    )]: (state, { payload }) => payload.lockingErrors || [],
  },
  [],
);

export default combineReducers({
  data,
  isLoading,
  error,
  isSaving,
  saveSuccess,
  lock,
  lockingErrorType,
  lockingErrors,
});
